export default __webpack_public_path__ + "static/media/fi_archive_completed.7495eff3.svg";